import { getSettings } from '../settings';

/** Short vibration pulse for a D-pad/control press, gated by the haptics
 * setting AND feature detection -- `navigator.vibrate` is typed as always
 * present in lib.dom.d.ts but is genuinely absent on many browsers
 * (desktop Safari/Chrome, iOS Safari entirely), so this checks `typeof`
 * before calling and NEVER throws into a press handler either way. */
export function hapticPulse(ms = 12): void {
  if (!getSettings().haptics) return;
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(ms);
    }
  } catch {
    // best-effort only -- a control press must never throw
  }
}
